import React from 'react';
import PropTypes from 'prop-types';
import Linkify from 'react-linkify';

import './QuestionHeader.scss';

const QuestionHeader = (props) => {
  const { text, descriptor, readOnly, isAnswerType, linkId } = props;

  const headingId = `question-heading-${linkId}`;

  const renderDescriptor = descriptor ? (
    <>
      <br />
      {descriptor}
    </>
  ) : null;

  return (
    <span
      className="questionnaire-question-prompt db"
      tabIndex={0}
      role="region"
      aria-labelledby={headingId}
    >
      <span id={headingId} className="questionnaire-question-prompt__label db">
        <Linkify properties={{ target: '_blank' }}>
          {text}
          {renderDescriptor}
          {readOnly && ':'}
          {isAnswerType && !readOnly && (
            <i className="fas fa-edit ml3" aria-hidden="true" />
          )}
        </Linkify>
      </span>
    </span>
  );
};

QuestionHeader.propTypes = {
  text: PropTypes.string.isRequired,
  descriptor: PropTypes.string,
  readOnly: PropTypes.bool,
  isAnswerType: PropTypes.bool,
  linkId: PropTypes.string.isRequired,
};

QuestionHeader.defaultProps = {
  descriptor: undefined,
  readOnly: false,
  isAnswerType: false,
};

export default QuestionHeader;
